<template>
  <v-container>
    <h1 class="text-center">ORDERS RECEIVED</h1>
    <template v-if="ONLINE_ORDERS.length>=1">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Name</th>
              <th class="text-left">Phone</th>
              <th class="text-left">Email</th>
              <th class="text-left">Address</th>
              <th class="text-left">Total</th>
              <th class="text-left">View</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in ONLINE_ORDERS" :key="item.id">
              <td>{{ item.name }}</td>
              <td>{{ item.phone }}</td>
              <td>{{ item.email }}</td>
              <td>{{ item.address}}</td>
              <td>{{ item.grandtotal | rupee}}</td>
              <td>
                <v-btn icon color="green" @click="viewItems(item)">
                  <v-icon>mdi-card-search-outline</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <template v-else>
      <v-alert type="info" class="text-center">No Orders Yet</v-alert>
    </template>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  activated() {
    this.getOrders();
  },
  computed: {
    ...mapGetters(["ONLINE_ORDERS"]),
  },
  methods: {
    ...mapActions(["GET_ONLINE_ORDERS"]),
    getOrders() {
      this.$store.commit("SET_LOADING", true);
      this.GET_ONLINE_ORDERS().then(() => {
        this.$store.commit("SET_LOADING", false);
      });
    },
    viewItems(item) {
      let routeData = this.$router.resolve({
        name: "ONLINE_ORDERS_ITEMS",
        params: { id: item.id },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style>
</style>